module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.3ac50b5b.ttf";